var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "options-tour-manual" },
    [
      _c(
        "v-btn",
        {
          staticClass: "options-tour-manual__fab az-shadow",
          attrs: {
            fab: "",
            color: "primary",
            "aria-label": "Abrir tour de novidades"
          },
          on: { click: _vm.emitTour }
        },
        [
          _c("icon-svg", {
            attrs: { name: "question", size: "30", color: "white" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }